import { Fragment, useContext, useEffect, useState } from 'react';
import { Col, Card, CardHeader, Table, Input, Row, ModalFooter } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import Pagination from '../../Components/Pagination/Pagination';
import Empty from '../../Components/Empty/Index';
import { useNavigate } from 'react-router';
import CustomizerContext from '../../_helper/Customizer';
import { getExamUser } from '../../store/userExamSlice';
import { gethelpSupport, updateSupportStatus } from '../../store/helpSupportSlice';
import CommonModal from '../../Components/Modals/modal';
import { Btn } from '../../AbstractElements';



const HelpSupportTable = () => {
  const storeVar = useSelector(state => state.helpSupport)
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { layoutURL } = useContext(CustomizerContext);
  const [typingTimer, setTypingTimer] = useState(null);
  const typingDelay = 800;
  const [isStatusModalOpen, setIsStatusModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [formVar, setFormVar] = useState({
    keyword: '',
    limit: 10,
    offset: 0,
    currentPage: 1,
    status:'pending'
  });

  useEffect(() => {
    dispatch(gethelpSupport(formVar.limit, formVar.offset, formVar.status))
  }, []);

  const pageChange = (page) => {
    const offset = formVar.limit * (page - 1)
    setFormVar((prevFormVar) => ({
      ...prevFormVar,
      currentPage: page,
      offset: offset
    }))
    dispatch(gethelpSupport(formVar.limit, offset, formVar.status))
  };
  const searchState = (e) => {
    setFormVar((prevFormVar) => ({ ...prevFormVar, keyword: e.target.value }))
    searchWithDelay(e.target.value)
  }
  const searchWithDelay = (keyword) => {
    clearTimeout(typingTimer);
    const timer = setTimeout(() => {
      dispatch(gethelpSupport(formVar.limit, formVar.offset, formVar.status))
    }, typingDelay);
    setTypingTimer(timer);
  };


  const handleInputChange = (e) => {
    setFormVar((prevFormVar) => ({ ...prevFormVar, status: e.target.value }))
    dispatch(gethelpSupport(formVar.limit, formVar.offset, e.target.value))

  };

  const statusToggleModal = (data) => {
    setSelectedItem(data);
    setIsStatusModalOpen(true);
  };

  const closeStatusModal = () => {
    setIsStatusModalOpen(false);
    setSelectedItem(null);
  };

  const handleResolveStatus = () => {
    if (selectedItem) {
      dispatch(updateSupportStatus(selectedItem._id, 'solved'));
    }
    closeStatusModal();
  };

  return (
    <Fragment>
      <Col sm='12'>
        <Card>
          <CardHeader>
            <Row>
              <Col md="4">
                <Input className="form-control form-control-inverse btn-square" name="select" type="select"
                  value={formVar.status} onChange={handleInputChange}>
                  <option value='solved'>SOLVED</option>
                  <option value='pending'>PENDING</option>
                </Input>
              </Col>
              <Col md="6">
              </Col>
              <Col md="2" className='d-flex justify-content-end align-items-center'>
              </Col>
            </Row>

          </CardHeader>
          <div className='table-responsive'>
            <Table hover={true} className='table-border-horizontal table-light'>
              <thead>
                <tr>
                  <th scope='col'>Sl.No</th>
                  <th scope='col'>Name</th>
                  <th scope='col'>Email Id</th>
                  <th scope='col'>Query</th>
                  <th scope='col'>Images</th>
                  <th scope='col'>Status</th>
                  <th scope='col'>Action</th>
                </tr>
              </thead>
              <tbody>
                {storeVar.helpSupportData?.map((item, index) => (
                  <tr key={index}>
                    <th scope='row'>{index + 1}</th>
                    <td >{item.userId?.name || 'N/A'}</td>
                    <td >{item.userId?.email || 'N/A'}</td>
                    <td >{item.query}</td>
                    <td >
                      {item.images && item.images.length > 0 ? (
                        <div className='d-flex gap-1 flex-wrap'>
                          {item.images.map((img, imgIdx) => (
                            <a key={imgIdx} href={img} target="_blank" rel="noopener noreferrer" title="Click to view full image">
                              <img 
                                src={img} 
                                alt={`Attachment ${imgIdx + 1}`} 
                                style={{ width: '44px', height: '44px', objectFit: 'cover', borderRadius: '8px', border: '1px solid #00a884', padding: '1px' }} 
                              />
                            </a>
                          ))}
                        </div>
                      ) : (
                        <span className='text-muted small'>-</span>
                      )}
                    </td>
                    <td >
                      {
                        item.status === 'solved' && <>
                          <span className={`font-success rounded-1 p-1 me-2 d-flex align-items-center`}>
                            <i className="fa fa-check-circle-o fa-lg" aria-hidden="true"></i>
                            &nbsp; <span>SOLVED</span>
                          </span>
                        </>
                      }
                      {
                        item.status === 'pending' && <>
                          <span className={`font-warning rounded-1 p-1 me-2 d-flex align-items-center`}>
                            <i className="fa fa-clock-o fa-lg" aria-hidden="true"></i>
                            &nbsp; <span>Pending</span>
                          </span>
                        </>
                      }
                    </td>
                    <td >
                      {item.status !== 'solved' && (
                        <div className='d-flex gap-2 align-items-center'>
                          <div className='cursor-pointer bg-light-info font-info action-icon' onClick={() => statusToggleModal(item)}>
                            <i className="fa fa-check-circle-o fa-lg"></i>
                            <div className="tooltipCustom">Status Update</div>
                          </div>
                        </div>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
          {
            storeVar.totalhelpSupport <= 0 && (
              <Empty />
            )
          }
        </Card>
        {
          storeVar.totalhelpSupport > 0 &&
          <Pagination currentPage={formVar.currentPage} totalItem={storeVar.totalhelpSupport}
            itemsPerPage={formVar.limit} showEllipsisAfter={true} visiblePageCount={3} onPageChange={pageChange} />
        }
      </Col>

      <CommonModal isOpen={isStatusModalOpen} title={'Update Status'} toggler={closeStatusModal}>
        <div style={{ color: '#1f2937' }}>
          <p className="mb-3 font-weight-bold" style={{ color: '#111827', fontSize: '15px' }}>
            Are you sure you want to resolve this query?
          </p>
          {selectedItem && (
            <div className='p-3 rounded mb-3' style={{ backgroundColor: '#f3f4f6', border: '1px solid #e5e7eb', color: '#1f2937' }}>
              <p className='mb-2' style={{ color: '#111827', fontSize: '14px' }}>
                <strong style={{ color: '#047857' }}>User:</strong> {selectedItem.userId?.name || 'N/A'} ({selectedItem.userId?.email || 'N/A'})
              </p>
              <p className='mb-2' style={{ color: '#111827', fontSize: '14px', whiteSpace: 'pre-wrap' }}>
                <strong style={{ color: '#047857' }}>Query:</strong> {selectedItem.query}
              </p>
              {selectedItem.images && selectedItem.images.length > 0 && (
                <div className="mt-3">
                  <strong className='d-block mb-2' style={{ color: '#111827', fontSize: '13px' }}>
                    Attached Images ({selectedItem.images.length}):
                  </strong>
                  <div className='d-flex gap-2 flex-wrap'>
                    {selectedItem.images.map((img, i) => (
                      <a key={i} href={img} target="_blank" rel="noopener noreferrer">
                        <img 
                          src={img} 
                          alt={`Attachment ${i + 1}`} 
                          style={{ width: '64px', height: '64px', objectFit: 'cover', borderRadius: '8px', border: '2px solid #10b981' }} 
                        />
                      </a>
                    ))}
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
        <ModalFooter className='justify-content-end gap-2'>
          <Btn attrBtn={{ color: 'secondary', onClick: closeStatusModal }}>Cancel</Btn>
          <Btn attrBtn={{ color: 'primary', onClick: handleResolveStatus }}>Resolve</Btn>
        </ModalFooter>
      </CommonModal>

    </Fragment>
  );
};

export default HelpSupportTable;
